import React from 'react';
import { Reveal, Section } from '@/components/ui';
import { resumeContent } from '@/content/resume';

/**
 * Experience section for the résumé/portfolio product variant (§11). See
 * `src/pages/ResumeDemo.tsx`.
 */
const ResumeExperience: React.FC = () => {
    return (
        <Section id="resume-experience" className="resume-experience" title="Experience" contained>
            <div className="resume-timeline">
                {resumeContent.experience.map((item, index) => (
                    <Reveal
                        as="div"
                        className="resume-timeline-item"
                        key={item.role}
                        delay={index * 100}
                    >
                        <p className="resume-timeline-period">{item.period}</p>
                        <h3 className="resume-timeline-role">
                            {item.role}{' '}
                            <span className="resume-timeline-company">@ {item.company}</span>
                        </h3>
                        <p className="resume-timeline-description">{item.description}</p>
                    </Reveal>
                ))}
            </div>
        </Section>
    );
};

export default ResumeExperience;
